import {createMuiTheme} from "@material-ui/core";
import {green} from "@material-ui/core/colors";

const CustomTheme = (themeType) => createMuiTheme({
    palette: {
        type: themeType,
        primary: {
            main: (themeType === 'light') ? '#008080' : '#ffffffb3'
        },
        secondary: {
            main: green[500]
        }
    },

})


export default CustomTheme;
